export default __webpack_public_path__ + "static/media/img6.27a44249.png";